import { isEmpty } from 'lodash/fp';

export default function DroughtData(currentMode, currentArea, datas, dataTime, thailandJson) {
  // eslint-disable-next-line no-unneeded-ternary
  const modeProvince = (currentMode === 'province' && currentArea.code > 0) ? true : false;

  const getProvinceCodeOrName = (prov) => {
    if (!isEmpty(thailandJson)) {
      return thailandJson.features
        .filter((d) => d.properties.prov_code === prov || d.properties.title === prov)
        .map((m) => ((m.properties.title === prov) ? m.properties.prov_code
          : m.properties.title)).toString();
    }
    return null;
  };

  // eslint-disable-next-line max-len
  const dataTable = datas.filter((d) => (modeProvince ? (d[0] === currentArea.code) : d)).map((row) => ({
    province_name: getProvinceCodeOrName(row[0]),
    date: row[2],
    time: row[3],
    rfhistorical: row[4],
    rfforcast: row[5],
  }));

  const groupData = [...new Set(dataTable.map((d) => d.province_name))].filter(Boolean);

  const countList = groupData.length;

  return ({
    count: countList,
    list: groupData,
    dataTable,
    dataTime,
  });
}
